import { useTab } from '../../database/tabs';
import { createTabIdPrefix } from '../../../util/createTabIdPrefix';
import { useProject } from '../ProjectContext';

export function useParentTabId() {
  const { projectId } = useProject();
  const { activeTab } = useTab();
  return createTabIdPrefix(projectId, activeTab.id);
}
